import { Button, DialogTitle, FormControl, FormLabel, Input, Modal, ModalDialog, Stack } from '@mui/joy';
import React, { useEffect, useState } from 'react';
import { IProject } from '../interface/IProject';
import projectApi from '../api/project';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  selectedProject: IProject | null;
};

const ProjectCreateModal = ({ open, onClose, onSave, selectedProject }: Props) => {
  const [project, setProject] = useState<Partial<IProject>>({});

  useEffect(() => {
    if (open) {
      if (selectedProject) {
        setProject({ name: selectedProject.name, projectId: selectedProject.projectId });
      }
    } else {
      setProject({});
    }
  }, [open]);

  return (
    <Modal
      aria-labelledby='modal-title'
      aria-describedby='modal-desc'
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
    >
      <ModalDialog>
        <DialogTitle> {selectedProject ? 'Update Project' : 'Create Project'}</DialogTitle>
        <form
          onSubmit={async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            try {
              const formData = new FormData(event.currentTarget);
              const formJson: IProject = Object.fromEntries((formData as any).entries()) as IProject;
              if (project.projectId) {
                await projectApi.updateProject(Number(project.projectId), formJson);
              } else {
                await projectApi.createProject(formJson);
              }
              onSave();
            } catch (e) {
              console.error(e);
            }
          }}
        >
          <Stack spacing={2}>
            <FormControl required>
              <FormLabel>Project Name</FormLabel>
              <Input
                type='text'
                name='name'
                value={project?.name || ''}
                onChange={(e) => setProject((prev) => ({ ...prev, name: e.target.value as string }))}
              />
            </FormControl>
            <Button type='submit'>Submit</Button>
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default ProjectCreateModal;
